import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-config-example-main-nav',
  templateUrl: './config-example-main-nav.component.html',
  styleUrls: ['./config-example-main-nav.component.css']
})
export class ConfigExampleMainNavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
